/** BCP-47-ish hint → content direction, independent of the application UI dir. */
export function templateContentDir(
  language: string | null | undefined,
): "rtl" | "ltr" | undefined {
  if (!language) return undefined;
  const normalized = language.trim().toLowerCase();
  if (normalized === "he" || normalized.startsWith("he_") || normalized.startsWith("ar")) {
    return "rtl";
  }
  if (normalized.length > 0) {
    return "ltr";
  }
  return undefined;
}
